'use client'

import {useState, useTransition} from 'react'
import {HgButton} from '~/design-system/hg/components/HgButton'
import {copyToClipboard} from '~/design-system/utils/copyToClipboard'
import {type CopyButtonProps} from './types'

export default function CopyButton({textToCopy}: CopyButtonProps) {
  const [isCopied, startTransition] = useTransition()
  const [copyCounter, setCopyCounter] = useState(0)

  const handleCopy = () => {
    startTransition(async () => {
      await copyToClipboard(textToCopy)
      setCopyCounter(prev => prev + 1)
      await new Promise(resolve => setTimeout(resolve, 1250))
    })
  }

  const copyLabel = isCopied ? 'Copied' : 'Copy code'

  return (
    <HgButton
      onClick={handleCopy}
      contentType="icon"
      variant="tonal"
      iconProps={{iconType: isCopied ? 'checkmark' : 'copy'}}
      className="absolute right-s2 top-s2 opacity-0 transition-opacity duration-200 focus-visible:opacity-100 group-hover:opacity-100 [&[data-copied=false]_svg]:animate-fadeInExtendedCopy [&[data-copied=true]_svg]:animate-fadeInExtended [&_svg]:opacity-0"
      aria-label={copyLabel}
      tooltip={copyLabel}
      data-analytics-event-name="blog-copy-code"
      data-copied={isCopied && copyCounter > 0}
    >
      Test
    </HgButton>
  )
}
